// HelperRatePlanName.jsx

import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const getLastDate = (item) => {
    const value = item?.lastResDate ?? item?.last ?? "";
    const date = String(value ?? "").split("T")[0];

    return date || "unknown";
};

const HelperRatePlanName = ({ label, renameInfo, disabled = false }) => {
    const text = String(label ?? "");
    const names = Array.isArray(renameInfo?.names) ? renameInfo.names : [];

    if (disabled || names.length < 2) {
        return text;
    }

    return (
        <Tooltip
            arrow
            placement="top"
            title={
                <Box sx={{ p: 0.5, maxWidth: 340 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                        This rate plan has been renamed
                    </Typography>

                    <Typography variant="caption" sx={{ display: "block" }}>
                        Known names and last booking date:
                    </Typography>

                    <Box sx={{ mt: 0.5 }}>
                        {names.map((item) => (
                            <Typography
                                key={`${item.name}-${getLastDate(item)}`}
                                variant="caption"
                                sx={{ display: "block" }}
                            >
                                • {item.name} — {getLastDate(item)}
                            </Typography>
                        ))}
                    </Box>

                    <Typography
                        variant="caption"
                        sx={{ display: "block", mt: 0.75, opacity: 0.8 }}
                    >
                        (Dates in this tooltip are updated weekly)
                    </Typography>
                </Box>
            }
        >
            <Box
                component="span"
                sx={{ cursor: "help", textDecoration: "underline dotted" }}
            >
                {text}
            </Box>
        </Tooltip>
    );
};

export default HelperRatePlanName;
